import { useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import useGetOrg from "src/hooks/useGetOrganization";
import Context from "src/pages/App/AppSettings/Customization/context";
import { useGetAppCustomizationRequest } from "src/services/organizations/queries/customization";

export const useGetCustomization = () => {
	const { state } = useContext(Context);
	const queryClient = useQueryClient();

	const { id } = useGetOrg();
	const appId = queryClient.getQueryData<string>(["apps", "selected"]) ?? "";

	const { data, isLoading } = useGetAppCustomizationRequest({ orgId: id, appId, type: state.type });

	return {
		data,
		isLoading
	};
};
